import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";

const renderApp = (Component) => {
  const rootElement = document.getElementById("fz-business-verification-root");

  // Check if the root element exists and has the correct ID
  if (rootElement) {
    const root = ReactDOM.createRoot(rootElement);
    root.render(<Component />);
  } else {
    // If the element with the specific ID is not found, render <App /> to the default root
    const defaultRootElement = document.getElementById("root");
    if (defaultRootElement) {
      const root = ReactDOM.createRoot(defaultRootElement);
      root.render(<Component />);
    } else {
      console.error("No valid root element found to render the App.");
    }
  }
};

// Render the App component
renderApp(App);
